// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2295":"490678a7","2382":"53d4e5bd","4767":"53d4e5bd","5477":"83aa789e","5522":"44c4d580","5810":"53d4e5bd","6084":"560e1e5d","8991":"44c4d580","9317":"560e1e5d"}[chunkId] + ".chunk.css";
};